<template>
   <div class="hotel-order-detail-inner-section voucher-summary-wrapper">
      <div class="voucher-summary-inner">
         <div class="voucher-summary-table-wrapper">
            <div class="voucher-summary-table-inner">
               <div class="voucher-summary-table-item">
                  <span class="item-label">{{ $t("orderDetail_lblVoucherStatus") }}</span>
                  <span class="item-value voucher-status masked"
                     ><i class="pnr-badge gts-badge-as-dot" :class="'EHtlVoucherStatus-' + summary.status"></i>{{ summary.status | enumHotelVoucherStatus }}</span
                  >
               </div>

               <div class="voucher-summary-table-item">
                  <span class="item-label">{{ $t("orderDetail_lblProvider") }}</span>
                  <span class="item-value masked">
                     <template v-if="summary.providerName == 'GTS_DIRECT'">
                        {{ $t("hotelOrderDetail_gtsDirect") }}
                     </template>
                     <template v-else>
                        {{ packages.type == 5 ? $t("orderDetail_lblPackageProviderSchimetterling") : summary.providerName }}
                     </template>
                  </span>
               </div>

               <div class="voucher-summary-table-item">
                  <span class="item-label">{{ $t("orderDetail_lblVoucher") }}</span>
                  <span class="item-value masked">{{ summary.voucher }}</span>
               </div>

               <div class="voucher-summary-table-item" v-if="this.$store.state.app.orderGsaType == 2">
                  <span class="item-label">{{ $t("orderDetail_lblVoucherId") }}</span>
                  <span class="item-value masked">{{ summary.id }}</span>
               </div>

               <div class="voucher-summary-table-item">
                  <span class="item-label">{{ $t("orderDetail_lblHotelName") }}</span>
                  <span class="item-value masked">{{ summary.hotelName }}</span>
               </div>

               <div class="voucher-summary-table-item">
                  <span class="item-label">{{ $t("orderDetail_lblCheckinDate") }}</span>
                  <span class="item-value masked">{{ summary.checkInDate | fullDateFormat }}</span>
               </div>

               <div class="voucher-summary-table-item">
                  <span class="item-label">{{ $t("orderDetail_lblCheckoutDate") }}</span>
                  <span class="item-value masked">{{ summary.checkOutDate | fullDateFormat }}</span>
               </div>

               <div class="voucher-summary-table-item" v-if="packages.type != 5">
                  <span class="item-label">{{ $t("orderDetail_lblTotalPrice") }}</span>
                  <span class="item-value masked">{{ summary.total | price(summary.currency) }}</span>
               </div>
            </div>

            <div class="voucher-summary-table-footer">
               <div class="voucher-summary-table-footer-inner">
                  <div class="voucher-summary-table-footer-item" v-if="!isPartialPaid">
                     <span class="item-label">{{ $t("orderDetail_lblLastBookingDate") }}</span>
                     <span class="item-text masked">{{ summary.lastBookingDateTime | fullDateFormat }} - {{ summary.lastBookingDateTime | TimeFormat }}</span>
                  </div>
                  <div class="voucher-summary-table-footer-item" v-if="isPartialPaid">
                     <span class="item-label">{{ $t("orderDetail_lblPartialPaymentLastBookingDate") }}</span>
                     <span class="item-text masked">{{ formattedFirstPaymentDate }}</span>
                  </div>
                  <div class="voucher-summary-table-footer-item" v-if="isPartialPaid">
                     <span class="item-label">{{ $t("orderDetail_lblPartialPaymentLastVoidDate") }}</span>
                     <span class="item-text masked">{{ formattedSecondPaymentDate }}</span>
                  </div>

                  <div class="voucher-summary-table-footer-item">
                     <span class="item-label">{{ $t("orderDetail_lblLastVoidDate") }}</span>
                     <span class="item-text masked">{{ summary.lastVoidDateTime | fullDateFormat }} - {{ summary.lastVoidDateTime | TimeFormat }}</span>
                  </div>

                  <div class="voucher-summary-table-footer-item">
                     <span class="item-label">{{ $t("orderDetail_lblReserveDate") }}</span>
                     <span class="item-text masked">{{ summary.reserveDateTime | fullDateFormat }} - {{ summary.reserveDateTime | TimeFormat }}</span>
                  </div>

                  <div class="voucher-summary-table-footer-item">
                     <span class="item-label">{{ $t("orderDetail_lblBookingDate") }}</span>
                     <span class="item-text masked">{{ summary.bookingDateTime | fullDateFormat }} - {{ summary.bookingDateTime | TimeFormat }}</span>
                  </div>
                  <div class="voucher-summary-table-footer-item">
                     <span class="item-label">{{ $t("orderDetail_lblReverseDate") }}</span>
                     <span class="item-text masked">{{ summary.reverseDateTime | fullDateFormat }} - {{ summary.reverseDateTime | TimeFormat }}</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import moment from "moment";

export default {
   name: "VoucherAndRoomInformationSummary",
   props: {
      packages: Object,
      voucherSummary: { type: Object },
      partialPaymentSummeryData: {},
      cancellationPolicies: {},
   },
   data() {
      return {
         summary: {},
      };
   },
   created() {
      const self = this;

      self.summary = this.voucherSummary;
   },
   computed: {
      isPartialPaid() {
         return this.partialPaymentSummeryData.length > 0;
      },
      formattedFirstPaymentDate() {
         return this.voucherSummary.lastDepositDateTime ? moment(this.voucherSummary.lastDepositDateTime).format("DD.MM.YYYY HH:mm") : "-";
      },
      formattedSecondPaymentDate() {
         return this.voucherSummary.lastBalanceDateTime ? moment(this.voucherSummary.lastBalanceDateTime).format("DD.MM.YYYY HH:mm") : "-";
      },
   },
   watch: {
      voucherSummary: {
         handler: function (newVoucherSummary) {
            const self = this;
            self.summary = newVoucherSummary;
         },
         deep: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.voucher-summary-wrapper {
   margin-bottom: 90px;
   .voucher-summary-inner {
      .voucher-summary-table-wrapper {
         display: flex;
         flex-direction: column;

         .voucher-summary-table-inner {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
            border: 1px solid var(--gray-300);
            border-radius: 10px 10px 0 0;
            overflow: hidden;

            .voucher-summary-table-item {
               display: grid;
               grid-template-rows: auto 1fr;

               .item-label {
                  font-size: 14px;
                  color: var(--gray-700);
                  background-color: var(--gray-200);
                  padding: 16px;
                  border-bottom: 1px solid var(--gray-300);
               }

               .item-value {
                  font-size: 16px;
                  font-weight: 700;
                  word-break: break-word;
                  background-color: white;
                  padding: 16px;

                  &.voucher-status {
                     display: inline-flex;
                     align-items: center;

                     > i {
                        margin-right: 0.5rem;
                     }
                  }
               }
            }
         }

         .voucher-summary-table-footer {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            .voucher-summary-table-footer-inner {
               width: 84%;
               display: grid;
               grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
               gap: 16px;
               padding: 24px;
               border: 1px solid var(--gray-300);
               border-top: none;
               border-radius: 0 0 8px 8px;

               @media (max-width: 767.98px) {
                  width: 100%;
               }

               .voucher-summary-table-footer-item {
                  display: flex;
                  flex-direction: column;
                  gap: 4px;

                  & > span {
                     font-size: 14px;
                  }
                  & > span.item-label {
                     color: var(--gray-500);
                  }
                  & > span.item-text {
                     font-weight: 700;
                     word-break: break-word;
                  }
               }
            }
         }

         @media (max-width: 767.98px) {
            .voucher-summary-table-inner {
               grid-template-columns: 1fr;

               .voucher-summary-table-item {
                  border-bottom: 1px solid var(--gray-300);

                  &:last-child {
                     border-bottom: none;
                  }

                  .item-label {
                     padding: 12px 16px;
                  }

                  .item-value {
                     padding: 12px 16px;
                  }
               }
            }

            .voucher-summary-table-footer {
               .voucher-summary-table-footer-inner {
                  grid-template-columns: 1fr;
                  padding: 16px;

                  .voucher-summary-table-footer-item {
                     padding-bottom: 12px;
                     border-bottom: 1px solid var(--gray-300);

                     &:last-child {
                        border-bottom: none;
                        padding-bottom: 0;
                     }
                  }
               }
            }
         }
      }
   }
}
</style>
